import React from 'react'

const Buttons = ({
  cancelUrl,
  isSubmitting,
  saveValue = 'Save',
  cancelText = 'Cancel'
}) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div style={{ width: '25%' }} />
      <div style={{ width: '20%', backgroundColor: '#002b45' }}>
        <input
          type='submit'
          value={saveValue}
          disabled={isSubmitting}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            color: 'white',
            display: 'block',
            fontFamily: 'BentonModernDisplaySemiBold',
            fontSize: '1em',
            fontWeight: 400,
            height: 40,
            margin: 0,
            textAlign: 'center',
            width: '100%'
          }}
        />
      </div>
      <div style={{ width: '20%', backgroundColor: '#002b45' }}>
        <a
          href={cancelUrl}
          style={{
            color: 'white',
            display: 'flex',
            fontFamily: 'BentonModernDisplaySemiBold',
            fontSize: '1em',
            fontWeight: 400,
            height: 40,
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            width: '100%'
          }}
        >
          {cancelText}
        </a>
      </div>
      <div style={{ width: '25%' }} />
    </div>
  )
}

export default Buttons
